import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {mbeConfigService} from './mbe-config.service';
import {Observable} from 'rxjs';
import {BasicResponse} from '@auth-suite-services/services';
import {InterestRate, InterestRateAPI} from '../model/interest-rate';
import { SortFilterInterface } from '@auth-suite-services/services';

@Injectable({
  providedIn: 'root',
})
export class InterestRateService {
  private URL;
  headers: HttpHeaders;

  constructor(
    @Inject(mbeConfigService) private config,
    private httpClient: HttpClient
  ) {
    this.URL =
      config.REST_SERVER_HOST +
      config.REST_SERVER_url.find((restUrl) => restUrl.api === 'MBE').url +
      '/ira';
    this.headers = new HttpHeaders().set('Content-Type', 'application/json');
  }

  getAllInterestRate(
    pageIndex?: number,
    pageSize?: number,
    sortActive?: string,
    sort?: string,
    sortFilter?: SortFilterInterface | Record<string, unknown>
  ): Observable<InterestRateAPI> {
    const headers = this.headers;
    // Plain JSON body so flat fields like groupDescription are posted correctly 21/07/2026 DW
    const body =
      sortFilter && typeof sortFilter === 'object'
        ? JSON.parse(JSON.stringify(sortFilter))
        : {};
    return this.httpClient.post<InterestRateAPI>(
      `${this.URL}/allinterestrate/${pageIndex}/${pageSize}/${
        sortActive ? sortActive : 'id'
      }/${sort ? sort : 'asc'}`,
      body,
      { headers }
    );
  }

  getInterestRate(id: number): Observable<InterestRate> {
    const headers = this.headers;
    return this.httpClient.get<InterestRate>(
      `${this.URL}/getinterestrate/${id}`,
      { headers }
    );
  }

  updateInterestRate(ira: InterestRate): Observable<BasicResponse> {
    const headers = this.headers;
    return this.httpClient.post<BasicResponse>(
      `${this.URL}/updateinterestrate`,
      ira,
      { headers }
    );
  }
  // Added                                          12/09/2024 PK
  createInterestRate(ira: InterestRate): Observable<BasicResponse> {
    const headers = this.headers;
    return this.httpClient.post<BasicResponse>(
      `${this.URL}/createinterestrate`,
      ira,
      { headers }
    );
  }
}
